import { routerReducer, RouterState } from '@ngrx/router-store';
import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  MetaReducer,
} from '@ngrx/store';
import {
  configsReducer,
  ConfigsState,
} from 'src/app/core/store/configs/configs.reducer';
import {
  consumerReducer,
  ConsumersState,
} from 'src/app/core/store/consumers/consumers.reducer';
import {
  distributorReducer,
  DistributorsState,
} from 'src/app/core/store/distributors/distributors.reducer';
import {
  languagesReducer,
  LanguagesState,
} from 'src/app/core/store/languages/languages.reducer';
import {
  planReducer,
  PlansState,
} from 'src/app/core/store/plans/plans.reducer';
import { EndUsersState } from '../dashboard/mobile/end-users/store/end-users.reducer';
import { accountReducer, AccountState } from './store/account/account.reducer';
import { AccountActions } from './store/account/action-types';
import {
  billingsReducer,
  BillingsState,
} from './store/billings/billings.reducer';
import { brandReducer, BrandsState } from './store/brands/brands.reducer';
import {
  countriesReducer,
  CountriesState,
} from './store/countries/countries.reducer';

export interface AppState {
  account: AccountState;
  brands: BrandsState;
  distributors: DistributorsState;
  plans: PlansState;
  consumers: ConsumersState;
  countries: CountriesState;
  router: RouterState;
  configs: ConfigsState;
  languages: LanguagesState;
  billings: BillingsState;
}

export const reducers: ActionReducerMap<AppState> = {
  account: accountReducer,
  brands: brandReducer,
  distributors: distributorReducer,
  plans: planReducer,
  consumers: consumerReducer,
  countries: countriesReducer,
  router: routerReducer,
  configs: configsReducer,
  languages: languagesReducer,
  billings: billingsReducer,
};

/**
 * Clear app state upon user logout
 * @param reducer
 * @returns
 */
export function clearState(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    if (action.type === AccountActions.logout.type) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = [clearState];
export const selectAccountState =
  createFeatureSelector<AccountState>('account');
export const selectBrandsState = createFeatureSelector<BrandsState>('brands');
export const selectDistributorsState =
  createFeatureSelector<DistributorsState>('distributors');
export const selectPlansState = createFeatureSelector<PlansState>('plans');
export const selectBillingsState =
  createFeatureSelector<BillingsState>('billings');
export const selectConsumersState =
  createFeatureSelector<ConsumersState>('consumers');
export const selectEndUsersState =
  createFeatureSelector<EndUsersState>('endUsers');
export const selectCountriesState =
  createFeatureSelector<CountriesState>('countries');
export const selectConfigsState =
  createFeatureSelector<ConfigsState>('configs');
export const selectLanguagesState =
  createFeatureSelector<LanguagesState>('languages');
